import { useTranslation } from 'react-i18next';
import { ALL_LOCALES, SUPPORTED_LOCALES } from '@/i18n/config';

/**
 * Tiny locale switcher used on the welcome screen and in settings.
 * In dev builds, the QA RTL stub locale is selectable so designers/testers
 * can verify RTL rendering. In production builds, it's hidden.
 */
export function LocaleSwitcher() {
  const { t, i18n } = useTranslation();
  const locales = import.meta.env.DEV ? ALL_LOCALES : SUPPORTED_LOCALES;

  return (
    <label className="flex items-center gap-2 text-sm text-muted">
      <span>{t('locale.name')}:</span>
      <select
        className="rounded-md border border-border bg-card px-3 py-1 text-foreground"
        value={i18n.resolvedLanguage ?? 'en'}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
      >
        {locales.map((lng) => (
          <option key={lng} value={lng}>
            {t(`locale.${lng === 'qa-rtl' ? 'qaRtl' : lng}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
